const {registerModule, KitModule} = window;

class Video extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindUI();
    this.bindEvents();
  }

  /**
   * @listens Modal#modalclose
   * @see _src/_includes/elements/modal/modal.js
   */
  bindEvents() {
    this.$element.addEventListener('click', this);
    if (this.modalId) this.$modal.addEventListener('modalclose', this.handleModalClose.bind(this));
  }

  bindUI() {
    this.$modal = document.getElementById(this.modalId);
  }

  /**
   * Pause the video on modal close
   */
  handleModalClose() {
    const iframe = this.$modal.querySelector('.lite-video iframe');
    const command = {
      method: 'pause',
      value: 'true',
    };
    if (iframe) {
      iframe.contentWindow.postMessage(JSON.stringify(command), '*');
    }
  }

  /**
   * The micromodalTrigger is an a element that links to the video URL so non-JS
   * users can still view the video. This disables the normal clicking behavior
   * of the <a> element.
   * @param {Event} event
   */
  onclick(event) {
    if (this.modalId) {
      event.preventDefault();
    } else {
      this.$cover.style.opacity = '0';
      this.$cover.style.visibility = 'hidden';
      this.$cover.style.pointerEvents = 'none';
      this.$videoPlayer.play();
    }
  }

  setVars() {
    this.modalId = this.$element.dataset.micromodalTrigger;
  }
}

registerModule('Video', Video);
